"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Все курсы",
    "className": "Название практикума",
    "continue": "Продолжать",
    "courseChapter": "Глава",
    "courseEvaluate": "Оценка",
    "courseHours": "Зачёт",
    "courseInfo": "Детали",
    "courseNote": "Примечания",
    "coursesCategory": "Категории курсов",
    "electiveCourses": "Факультативный курс",
    "pages": "Страница",
    "relatedCourses": "Соответствующие курсы",
    "requiredCourses": "Лекция",
    "searchTips": "Введите название курса",
    "studentsNum": "Аудитория",
    "teachersDesc": "Преподаватель",
    "newCourse": "Последние курсы"
  },
  "footer_zlb": {
    "aboutUs": "О нас",
    "downLoad": "Загрузить приложение",
    "qr": "QR-код"
  },
  "global_zlb": {
    "am": "До полудня",
    "isa": "　",
    "night": "Вечер",
    "pm": "После полудня"
  },
  "header_zlb": {
    "accoutPw": "Пароль учетной записи",
    "curDis": "Текущий",
    "curUser": "Текущий пользователь",
    "edit": "Обновить",
    "helpCenter": "Справочный центр",
    "hisDis": "История",
    "index": "Домашняя страница",
    "joinStore": "Добавить в избранное",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Сообщение",
    "setIndex": "Установить в качестве домашней страницы",
    "userImg": "Фото профиля"
  },
  "index_zlb": {
    "discuss": "Практикум",
    "find": "Найти",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Я"
  },
  "info_zlb": {
    "admin": "Администратор",
    "hasAgenda": "Вы уже присоединились к занятиям.",
    "noDown": "Нет вложений для загрузки!",
    "pleaseInp": "Введите",
    "submit": "Успешно сдано!",
    "withinTime": "Задача еще не началась",
    "noSubmitWork": "Задание не представлено"
  },
  "login_zlb": {
    "accountLogin": "Войти",
    "accountNotEmpty": "Учётная запись должна быть заполнена",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Отмена",
    "captchaNotEmpty": "Проверочный код должен быть заполнен",
    "captchaTips": "Неверный проверочный код",
    "changeEmail": "Обновить электронную почту",
    "changeEmailSuccess": "Адрес электронной почты успешно обновлен.",
    "changeEmailSuccessTips": "Вы успешно обновили свою электронную почту.",
    "Confirm": "Подтвердить",
    "currentEmail": "Текущая электронная почта",
    "emailCaptcha": "Код подтверждения электронной почты",
    "emailCaptchaEmpty": "Проверочный код электронной почты должен быть заполнен",
    "encryEmail": "электронная почта безопасности",
    "error": "Ошибка проверочного кода",
    "forget": "Забыл пароль",
    "formerEamil": "Оригинальная электронная почта",
    "incorrectTips": "Ошибка ввода имени пользователя или пароля",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Новая электронная почта",
    "newEmailBinded": "Новая электронная почта связана с вашей учётной записью",
    "newEmailEmpty": "Новая электронная почта должна быть заполнена",
    "newEmailFomat": "Неверный формат новой электронной почты",
    "newEmailSupport": "Старый и новый адреса электронной почты не совпадают",
    "prevStep": "Последний шаг",
    "nextStep": "Следующий шаг",
    "reset": "Сброс",
    "loginNow": "Войдите сейчас",
    "resetSuccess": "Сброс удался",
    "resetSuccessTips": "Вы успешно переустановили пароль Перейдите к авторизации",
    "msgCaptcha": "Код подтверждения SMS",
    "getCaptcha": "Получить проверочный код",
    "resetPassword": "Сброс пароля",
    "loginFail": "Войти не удалось, попробуйте ещё раз!",
    "failTips": "Проверка не удалась",
    "inputUserName": "Имя пользователя",
    "goHome": "Перейти на домашнюю страницу",
    "passwordFormat": "Пароли должны состоять из 8-32 цифр и содержать цифры, а также прописные и строчные буквы.",
    "surePasswordEmpty": "Подтверждения пароля должно быть заполнено",
    "confirmNot": "Пароль и пароль подтверждения не совпадают",
    "changePasswordSuccess": "Пароль успешно обновлен",
    "continueLogin": "Войдите ещё раз",
    "orError": "Неверное имя пользователя или пароль",
    "orgEmailEmpty": "Исходная электронная почта должна быть заполнена",
    "orgEmailFormat": "Неверный формат исходной электронной почты",
    "orgEmailNot": "Исходный адрес электронной почты неверен",
    "passWord": "Пароль",
    "surePassword": "Подтвердите пароль",
    "passwordBits": "Длина пароля должна быть не менее 6 символов",
    "passwordNotEmpty": "Пароль должен быть заполнен",
    "pWord": "Пароль",
    "sign": "Войти",
    "uName": "Учётная запись",
    "userName": "Имя пользователя",
    "validate": "Код подтверждения",
    "verification": "Завершите проверку ниже",
    "appdownload": "Загрузить приложение",
    "scancode": "Сканируйте QR-код для загрузки",
    "poor": "Слабый",
    "middle": "Средний",
    "strong": "Сильный"
  },
  "login": {
    "logout": "Успешно выйдите из системы",
    "resetLoginTips": "Вы успешно сменили пароль, вам нужно снова войти в систему и автоматически выйти через 3 секунды",
    "sure": "Подтвердить",
    "cancel": "Отмена",
    "captchaNotEmpty": "Проверочный код должен быть заполнен",
    "accountNotEmpty": "Учётная запись должна быть заполнена",
    "passwordNotEmpty": "Пароль должен быть заполнен",
    "inputCaptcha": "Код подтверждения",
    "getCaptcha": "Получить проверочный код",
    "inputOrigPassword": "Введите оригинальный пароль",
    "inputNewPassowrd": "Введите новый пароль",
    "confimPassword": "Подтвердите пароль",
    "changePassword": "Изменить пароль",
    "nextStep": "Следующий шаг",
    "resetPassword": "Сброс пароля",
    "resetDone": "Сброс пароля удался",
    "msgCaptcha": "Код подтверждения электронной почты"
  },
  "look_zlb": {
    "aboutLecturer": "Соответствующие курсы",
    "benginLearn": "Начать обучение",
    "chapter": "Глава",
    "delete": "Удалить",
    "details": "Детали",
    "download": "Загрузить",
    "dynamic": "Новости",
    "evaluation": "Оценка",
    "hotDyc": "Отслеживание",
    "lecture": "Открытый курс",
    "lecturer": "Преподаватель",
    "lectureTest": "Категории курсов",
    "look": "Найти",
    "lookAll": "Посмотреть все",
    "note": "Примечания",
    "score": "Счет"
  },
  "myMessage_zlb": {
    "passwordError": "Ошибка ввода оригинального пароля",
    "aboutUs": "О нас",
    "allcourse": "Все курсы",
    "atypism": "Эти два пароля не совпадают",
    "birth": "Дата рождения",
    "cancel": "Отмена",
    "carryOut": "Завершить",
    "changePassword": "Изменить пароль",
    "chineseName": "Китайское имя",
    "chineseNamePlaceholder": "Введите китайское имя",
    "code": "Код подтверждения",
    "codeError": "Ошибка проверочного кода",
    "comment": "Примечание",
    "complete": "Завершить",
    "completeUserInfo": "Заполните личную информацию",
    "confirm": "Подтвердите пароль",
    "continueStudy": "Продолжать",
    "country": "Страна",
    "countryName": "Имя",
    "countryNamePlaceholder": "Введите своё имя",
    "countryPlaceholder": "Выберите страну",
    "courseLearned": "Завершено",
    "delete": "Удалить",
    "documentType": "Тип документа, удостоверяющего личность",
    "downloaded": "Загружено",
    "downloading": "Загрузка",
    "eduLevel": "Уровень образования",
    "eduLevelPlaceholder": "Выберите уровень образования",
    "email": "Электронная почта",
    "emailCode": "Код подтверждения электронной почты",
    "gender": "Пол",
    "genderPlaceholder": "Выберите пол",
    "getCode": "Получить проверочный код электронной почты",
    "hasSent": "Отправлено",
    "helpCenter": "Справочный центр",
    "hour": "Час",
    "improveInformation": "Заполните вашу личную информацию",
    "joinClasses": "Посещаемые курсы",
    "joinDis": "Посещаемые практикумы",
    "learned": "Завершено",
    "learning": "В процессе ",
    "lecture": "Курс",
    "mailbox": "Электронная почта",
    "mailboxValidate": "Ошибка проверки электронной почты",
    "man": "Мужской",
    "management": "Настройки",
    "minutes": "x часов x минут",
    "modify": "Обновить",
    "modifyEmail": "Обновить электронную почту",
    "my": "Я",
    "myCertificate": "Мой сертификат",
    "mycourse": "Мой Курс",
    "myDownload": "Моя загрузка",
    "myLecture": "Мой Курс",
    "myNotes": "Мои заметки",
    "newMail": "Новая электронная почта",
    "newPassword": "Новый пароль",
    "nextStep": "Следующий шаг",
    "orError": "Неверное имя пользователя или пароль",
    "origin": "От",
    "originalPassword": "Оригинальный пароль",
    "password": "Пароль",
    "phone": "Номер телефона",
    "pleChoose": "Выберите дату рождения",
    "post": "Почта",
    "postPlaceholder": "Введите почту",
    "religion": "Вероисповедание",
    "religionPlaceholder": "Выберите вероисповедание",
    "retrievePassword": "Получить пароль",
    "setUp": "Настройки",
    "signOut": "Выйти",
    "something": "Я хотел бы сказать",
    "submit": "Представить",
    "sureDelte": "Вы действительно хотите удалить?",
    "teacher": "Лектор",
    "learnYet": "Еще не начал учиться",
    "uName": "Имя пользователя",
    "uNamePlaceholder": "Имя пользователя",
    "userCenter": "Личная информация",
    "username": "Имя пользователя",
    "validateMsg": "Проверка не удалась",
    "woman": "Женский",
    "learnTo": "Прогресс",
    "myRecord": "Мой рекорд",
    "plePhone": "Введите номер телефона"
  },
  "notice_zlb": {
    "delete": "Удалить",
    "home": "Домашняя страница",
    "lettre": "Личное сообщение",
    "lettreEmpty": "Личное сообщение должно быть заполнено",
    "messageDetail": "Подробности сообщения",
    "myMessage": "Моё сообщение",
    "notice": "Примечание",
    "nowBavarder": "Теперь вы можете начать общаться",
    "send": "Отправить"
  },
  "play_zlb": {
    "networkTip": "Сетевое уведомление",
    "streamHighTip": "Текущее сетевое соединение стабильно. Мы переключились на режим высокой четкости для вас.",
    "streamHighType": "HD",
    "streamNormTip": "Текущее сетевое соединение нестабильно. Мы переключились на стандартный режим для вас.",
    "streamNormType": "SD",
    "liveTimeDes": "Время прямой трансляции",
    "livePlayWait": "Прямая трансляция не началась",
    "livePlayEnd": "Прямая трансляция закончилась"
  },
  "questionnaire_zlb": {
    "handed": "Представить",
    "saveFailed": "Ошибка сохранения",
    "examList": "Список тестовых вопросов"
  },
  "research_zlb": {
    "afternoon": "После полудня",
    "all": "Все",
    "allCalendar": "Все занятия",
    "alumniBook": "Член",
    "broadcast": "x начать трансляцию",
    "carriedout": "В процессе",
    "certificate": "Сертификат",
    "comment": "Примечание",
    "comments": "Все х замечаний",
    "courses": "Ссылка",
    "curDis": "Текущий",
    "default": "Не начато",
    "delete": "Удалить",
    "detail": "Детали",
    "discuss": "Форум",
    "end": "Завершено",
    "endAssess": "Оценка закончена",
    "enterAssess": "Начать оценку",
    "assessButton": "Обратная связь",
    "evaluation": "Оценка",
    "fileAcept": "Неправильный тип файла, загрузите снова.",
    "fileSize10": "Выбранный файл превышает 10 м, загрузите снова.",
    "hisDis": "История",
    "lecture": "Ссылка",
    "live": "Прямой эфир",
    "livebroadcast": "Прямая трансляция",
    "minutes": "x минут назад",
    "month": "Месяц",
    "morning": "До полудня",
    "noDiscussion": "Практикума нет",
    "noSchedule": "Занятий нет",
    "notice": "Примечание",
    "notification": "Непрочитанное примечание",
    "offline": "Очная лекция",
    "onging": "В процессе",
    "online": "Онлайн",
    "operation": "Назначение",
    "over": "Завершено",
    "participated": "Уже участвовал ",
    "notParticipate": "Предстоит участвовать ",
    "failedCourse": "Не прошло",
    "passedCourse": "Прошло",
    "preparation": "Подготовка задания",
    "preparations": "Подготовка задания",
    "preschoolLecture": "Подготовительная лекция",
    "questionnaire": "Опросник",
    "questionType ": "множественный выбор (только один ответ верен, отметьте все правильные ответы)",
    "readySay": "Я хотел бы сказать",
    "replies": "У вас есть x новых ответов",
    "save": "Сохранить",
    "schedule": "Занятия",
    "searchC": "Поиск интересующих вас тем",
    "seeAssess": "Просмотр оценки",
    "submit": "Представить",
    "submitHomewor": "Отмена",
    "task": "Задание",
    "taskToday": "Задание на сегодня",
    "video": "Видео",
    "week": "Неделя",
    "yourcomment": "Запишите свой комментарий",
    "legend": "Легенда",
    "sunday": "Воскресенье",
    "monday": "Понедельник",
    "tuesday": "Вторник",
    "wednesday": "Среда",
    "thursday": "Четверг",
    "friday": "Пятница",
    "saturday": "Суббота",
    "consult": "Справочные материалы",
    "schedules": "Задания",
    "calendar": "Календарь",
    "waitAssesment": "Вопросник, подлежащий представлению",
    "year": "Год",
    "day": "День",
    "preview": "Предварительный просмотр",
    "resource": "Загрузить"
  },
  "retrieve_zlb": {
    "emailEmpty": "Адрес электронной почты должен быть заполнен.",
    "emailVerif": "Проверка электронной почты"
  },
  "task_zlb": {
    "downF": "Загрузить вложения",
    "repeatUp": "Повторная загрузка",
    "ruY": "Если одно вложение было загружено в приложение, оно будет перезаписано, если вы загрузите другое на ПК.",
    "submitC": "Пожалуйста, введите то, что вы хотите отправить",
    "uploadF": "Загрузка вложений"
  },
  "upload_zlb": {
    "clickHere": "кликните здесь",
    "limit": "Формат файла поддерживает PNG, размер JPG не может превышать",
    "preview": "Предварительный просмотр после загрузки изображения",
    "upload": "Загрузить"
  },
  "index": {
    "setAsHomePage": "Установить в качестве домашней страницы",
    "addCollection": "Добавить в избранное",
    "telephone": "Горячая линия",
    "Help": "Справочный центр",
    "SystemMessage": "Системное уведомление",
    "message": "Личное сообщение",
    "emptyMessage": "Очистить",
    "checkAllMessage": "Посмотреть все",
    "noMessage": "Нет данных",
    "fullScreen": "Полноэкранный дисплей",
    "ExitSystem": "Выйти из этой системы",
    "back": "Назад",
    "top": "Верх",
    "backToTop": "Вернуться вверх",
    "homePage": "Домашняя страница",
    "favoriteTips": "Из-за ограничений браузераf 360/Google, нажмите Ctrl + D чтобы собрать вручную!",
    "autoSetHomeTips": "Ваш браузер не поддерживает автоматическую настройку домашней страницы, используйте меню браузера, чтобы настроить её вручную!",
    "currentUser": "Текущий пользователь",
    "userHead": "Фото профиля",
    "accountPassword": "Пароль учетной записи",
    "change": "Обновить",
    "head": "Фото профиля",
    "continueStudy": "Продолжать",
    "startStudy": "Начать обучение"
  },
  "course": {
    "count": "общие",
    "item": "Статья",
    "up": "Предыдущая страница",
    "next": "Следующая страница",
    "items": "на страницу",
    "go": "Перейти к",
    "page": "Страница",
    "man": "Пользователь",
    "score": "Счет",
    "courseYear": "Год",
    "courseTeachers": "Лектор",
    "noDesc": "Без введения",
    "teachersDesc": "Профиль преподавателя",
    "checkLog": "Просмотр записей",
    "startStudy": "Начать обучение",
    "JoinLearning": "Присоединиться",
    "isEvaluate": "Оценено",
    "deleteNoteButton": "Удалить",
    "closeButton": "Закрыть",
    "noteSource": "От"
  },
  "onlineclass": {
    "myScore": "Мой счет",
    "comments": "Примечание",
    "iknow": "Я знаю",
    "detail": "Детали",
    "inforCertificate": "Сертификат",
    "wantTalk": "Я хочу это прокомментировать",
    "inputTalkContent": "Введите комментарий",
    "publish": "Выпустить",
    "undo": "Отмена",
    "reply": "Ответить",
    "delete": "Удалить",
    "Learned": "Завершено",
    "isDelete": "Вы действительно хотите это удалить?",
    "submitTime": "Время подачи",
    "to": "кому",
    "download": "Загрузить"
  },
  "usercenter": {
    "htllo": "Привет",
    "welcomeMessage": "Хорошего дня",
    "searchTips": "Ищите курс, который вам нравится",
    "myCertificate": "Мой сертификат",
    "startQuestionnaire": "Начните отвечать",
    "empty": "ничего",
    "confirmDelete": "Подтверждение удаления",
    "confirmDeleteTips": "Вы действительно хотите это удалить?",
    "delete": "Удалить",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Окончание обучения",
    "tips": "Советы",
    "playTips": "Советы: Нажмите кнопку \"Окончание обучения\" в правом верхнем углу, чтобы выйти. Если вы окончите обучение, закрыв браузер, ваше время обучения может быть записано неправильно.",
    "notShowAgain": "Больше не напоминать",
    "gotIt": "Я знаю",
    "chapter": "Глава",
    "language": "Язык",
    "chapterText1": "№",
    "chapterText2": "Глава",
    "note": "Примечания",
    "noteBlockTitle": "Примечания",
    "evaluate": "Оценка",
    "evaluateStar": "Звезда",
    "saveEvaluate": "Представить",
    "notePlaceholder": "Делайте заметки",
    "closeTips": "Внесённые вами изменения не могут быть сохранены",
    "closeButton": "Оставить",
    "autoStop": "Автоматическая остановка воспроизведения",
    "autoStopTips": "Учёт бездействия пользователя. Воспроизведение автоматически останавливается.",
    "confirmOut": "Вы действительно хотите прекратить воспроизведение?",
    "closeOrNot": "Закройте текущее окно",
    "noCoursePlay": "В текущем курсе нет воспроизводимых источников",
    "attention": "Внимание!"
  },
  "assessment_zlb": {
    "score": "Счет",
    "evalSuccess": "Успешная оценка"
  },
  "undefined": {}
};